export default __webpack_public_path__ + "static/screen_2-ec66fa5495f89f5c631be0c36097245f.jpeg";